import { HistoryResponseInt } from '@gate31/core/src/api/gate31-api';
import { Base } from '@gate31/core/src/libs/BaseComponent';
import { SPECIAL_DISCOUNTS, SpecialGroups } from '@gate31/feature/Loyalty/constant';
import { ClientResponseInt } from '@gate31/types/client';

interface BalanceData {
        balance: {
            available: number;
            blocked: number;
        };
        customer?: any;
        level: string;
        segments: string[];
    }

interface AccountMilesOptions {
    clientData: ClientResponseInt;
    balanceData: BalanceData;
    historyData: HistoryResponseInt;
}

export class AccountMilesDesk extends Base<HTMLElement> {
    static cn = new Base.BuildCn('AccountMilesDesk');

    clientData: ClientResponseInt;
    balanceData: BalanceData;
    historyData: HistoryResponseInt;

    toggleTitle: HTMLElement | null;
    content: HTMLElement | null;

    LevelValueNode: HTMLElement | null;
    activeValueNode: HTMLElement | null;
    awaitingValueNode: HTMLElement | null;

    nextLevel: HTMLElement | null;
    nextLevelName: HTMLElement | null;
    nextLevelBalance: HTMLElement | null;

    history: HTMLElement | null;
    historyList: HTMLElement | null;

    // installCardNode: HTMLElement | null;
    // installCardLink: HTMLLinkElement | null;

    installAppNode: HTMLElement | null;

    discountHeader: HTMLElement | null;
    activeHeader: HTMLElement | null;
    awaitingHeader: HTMLElement | null;
    discountValue: HTMLElement | null;

    areMilesDisallowed: boolean;

    constructor(node: HTMLElement, options: AccountMilesOptions) {
        super(node);

        this.clientData = options.clientData;
        this.balanceData = options.balanceData;
        this.historyData = options.historyData;

        this.toggleTitle = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('toggle-title').toSelector());
        this.content = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('content').toSelector());

        this.LevelValueNode = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('level-value').toSelector());
        this.activeValueNode = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('active-value').toSelector());
        this.awaitingValueNode = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('awaiting-value').toSelector());

        this.nextLevel = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('next-level').toSelector());
        this.nextLevelName = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('next-level-name-value').toSelector());
        this.nextLevelBalance = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('next-level-balance-value').toSelector());

        this.history = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('history').toSelector());
        this.historyList = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('history-list').toSelector());

        // this.installCardNode = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('install-card').toSelector());
        // this.installCardLink = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('install-card-link').toSelector());


        this.installAppNode = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('install-app').toSelector());

        this.discountHeader =
            this.getRoot().querySelector(AccountMilesDesk.cn.setElem('discount').toSelector());
        this.activeHeader = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('active').toSelector());
        this.awaitingHeader = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('awaiting').toSelector());
        this.discountValue = this.getRoot().querySelector(AccountMilesDesk.cn.setElem('discount-value').toSelector());

        this.areMilesDisallowed = [ 'HOME31', 'Партнер' ].includes(this.balanceData.level);

        this.connectionCallback();
    }

    connectionCallback() {
        this.showBonuses();
        this.showNextLevel();
        // this.showCardLink();
        this.showAppLink();
        this.showHistory();
        this.initToggleContent();
        this.showHeaders();
    }

    initToggleContent() {
        if (this.toggleTitle && this.content) {
            this.toggleTitle.addEventListener('click', () => {
                this.content?.classList.toggle('show');
            });
        }
    }

    showHistory() {
        if (this.historyData.history?.length && ! this.areMilesDisallowed) {
            this.history?.classList.remove(AccountMilesDesk.cn.setElem('hidden').toString());
        }

        if (this.historyList) {
            const list = this.historyData?.history?.map(item => {
                return `
                <div class="AccountMilesDesk__line AccountMilesDesk__history-list-item">
                    <div>${item.name}</div>
                    <div class="AccountMilesDesk__history-list-item-value">
                        ${`+ ${item.changes.earned?.toLocaleString('ru-RU')}` || `- ${item.changes.spent?.toLocaleString('ru-RU')}`}
                        <i class="icon icon_type_miles AccountMilesDesk__active-icon">
                            <svg class="icon__svg AccountMilesDesk__active-icon-svg" width="18px" height="18px" xmlns="http://www.w3.org/2000/svg" version="1.1">
                                <use xlink:href="#miles"></use>
                            </svg>
                        </i>
                    </div>
                </div>
            `;
            }).join('');

            this.historyList.innerHTML = list;
        }
    }

    // showCardLink() {
    //     if (this.balanceData.customer?.customFields?.walletCardLink && this.installCardNode && this.installCardLink) {
    //         this.installCardLink.href = this.balanceData.customer?.customFields?.walletCardLink;
    //         this.installCardNode?.classList.remove(AccountMilesDesk.cn.setElem('install-card').setMode({ hidden: true }).toString());
    //     }
    // }

    showAppLink() {
        const isImshopApp = Boolean(this.balanceData.segments.find(item => item === 'Пользователи с мобильным приложением'));

        if (! isImshopApp && this.installAppNode) {
            this.installAppNode?.classList.remove(AccountMilesDesk.cn.setElem('install-app').setMode({ hidden: true }).toString());
        }
    }

    showNextLevel() {
        if (this.historyData?.level?.nextLevelName && this.historyData?.level?.nextLevelBalance && ! this.areMilesDisallowed) {
            this.nextLevel?.classList.remove(AccountMilesDesk.cn.setElem('hidden').toString());
        }

        if (this.nextLevelName && this.historyData?.level?.nextLevelName) {
            this.nextLevelName.innerHTML = this.historyData?.level?.nextLevelName;
        }

        if (this.nextLevelBalance && this.historyData?.level?.nextLevelBalance) {
            this.nextLevelBalance.innerHTML = Math.abs(this.historyData.level.nextLevelBalance)?.toLocaleString('ru-RU') + ' ₽';
        }
    }

    showBonuses() {
        if (this.LevelValueNode && this.balanceData.level) {
            this.LevelValueNode.textContent = this.balanceData.level;
        }

        if (this.activeValueNode && this.balanceData.balance.available) {
            this.activeValueNode.textContent = this.balanceData.balance.available.toLocaleString();
        }

        if (this.awaitingValueNode && this.balanceData.balance.blocked) {
            this.awaitingValueNode.textContent = this.balanceData.balance.blocked.toLocaleString();
        }

        if (this.areMilesDisallowed && this.discountValue) {
            const discountValue = SPECIAL_DISCOUNTS[this.balanceData.level as SpecialGroups];

            if (discountValue) {
                this.discountValue.textContent = discountValue.toLocaleString() + '%';
            }
        }
    }

    showHeaders() {
        if (this.discountHeader && this.activeHeader && this.awaitingHeader && this.areMilesDisallowed) {
            this.discountHeader?.classList.remove(AccountMilesDesk.cn.setElem('hidden').toString());
            this.activeHeader?.classList.add(AccountMilesDesk.cn.setElem('hidden').toString());
            this.awaitingHeader?.classList.add(AccountMilesDesk.cn.setElem('hidden').toString());
        }
    }
}
